import type { Timestamp } from 'firebase/firestore';

export function formatFeedbackTime(ts: Timestamp | null): string {
  if (!ts || typeof ts.toMillis !== 'function') {
    return 'Recently';
  }
  const diffMs = Date.now() - ts.toMillis();
  const seconds = Math.max(1, Math.floor(diffMs / 1000));
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  if (days > 0) return `${days}d ago`;
  if (hours > 0) return `${hours}h ago`;
  if (minutes > 0) return `${minutes}m ago`;
  return 'Just now';
}
